import { useState } from 'react';
import { useAuth } from '../AuthContext';
import { useTheme } from '../ThemeContext';
import toast from 'react-hot-toast';
import NavIcon from '../components/NavIcon';

export default function Login() {
  const { login } = useAuth();
  const { isDark, toggle } = useTheme();
  const [form, setForm]       = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
    } catch (err) {
      toast.error(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap" style={{ position: 'relative' }}>

      {/* Theme toggle — top-right corner */}
      <button className="login-theme-btn" onClick={toggle} title={isDark ? 'Light mode' : 'Dark mode'}>
        <NavIcon name={isDark ? 'sun' : 'moon'} size={16} />
      </button>

      <div className="login-card">
        <div className="login-logo">
          <h1>StoreBook</h1>
          <p>Inventory Management and Reporting</p>
        </div>

        <form onSubmit={handle} className="login-form">
          <h2>Sign in</h2>
          <p className="login-sub">Enter your credentials to continue</p>

          <div className="field">
            <label>Username</label>
            <input
              type="text"
              value={form.username}
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              placeholder="admin"
              autoFocus
              required
            />
          </div>

          <div className="field" style={{ marginTop: 12 }}>
            <label>Password</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary login-btn" disabled={loading}
            style={{ marginTop: 20 }}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="login-footer">
          Default credentials: <strong>admin</strong> / <strong>admin123</strong>
        </div>
      </div>
    </div>
  );
}
